/** One guide chapter at a time, with a persistent table of contents. */
export function initFieldManual(dialog: HTMLDialogElement): void {
    const contents = dialog.querySelector<HTMLElement>(".momo-manual-body")!;
    const sections = Array.from(contents.querySelectorAll<HTMLElement>(":scope > section"));
    const links = Array.from(dialog.querySelectorAll<HTMLButtonElement>("[data-momo-section]"));
    const previous = dialog.querySelector<HTMLButtonElement>("#momo-manual-previous")!;
    const next = dialog.querySelector<HTMLButtonElement>("#momo-manual-next")!;
    const finish = dialog.querySelector<HTMLButtonElement>("#momo-manual-finish")!;
    const progress = dialog.querySelector<HTMLElement>("#momo-manual-progress")!;
    let current = 0;

    const select = (index: number, focusHeading = true): void => {
        current = Math.max(0, Math.min(sections.length - 1, index));
        sections.forEach((section, i) => { section.hidden = i !== current; });
        links.forEach((link, i) => {
            if (i === current) link.setAttribute("aria-current", "step");
            else link.removeAttribute("aria-current");
        });
        previous.disabled = current === 0;
        const last = current === sections.length - 1;
        next.hidden = last;
        finish.hidden = !last;
        if (!last) next.textContent = `Next: ${links[current + 1].textContent!.trim().replace(/^\d+\s*/, "")} →`;
        progress.textContent = `${current + 1} / ${sections.length}`;
        progress.setAttribute("aria-label", `Section ${current + 1} of ${sections.length}`);
        contents.scrollTop = 0;
        if (focusHeading) {
            const heading = sections[current].querySelector<HTMLHeadingElement>("h3")!;
            heading.tabIndex = -1;
            heading.focus({ preventScroll: true });
            links[current].scrollIntoView({ block: "nearest", inline: "nearest" });
        }
    };

    links.forEach(link => link.addEventListener("click", () => {
        const index = sections.findIndex(section => section.id === link.dataset.momoSection);
        if (index !== -1) select(index);
    }));
    previous.addEventListener("click", () => select(current - 1));
    next.addEventListener("click", () => select(current + 1));

    // Start at an existing chapter link, then remember the reader's place.
    dialog.addEventListener("toggle", () => {
        if (dialog.open) select(current);
    });
    const initial = sections.findIndex(section => `#${section.id}` === location.hash);
    select(initial === -1 ? 0 : initial, false);
}
